<template>
  <div
    ref="toastEl"
    class="toast align-items-center text-white border-0 show"
    :class="status === 'danger' ? 'bg-danger' : 'bg-dark'"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="d-flex">
      <div class="toast-body">{{ message }}</div>
      <button
        type="button"
        class="btn-close btn-close-white me-2 m-auto"
        aria-label="Close"
        @click="hideToast"
      ></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationToast",
  props: {
    message: {
      type: String,
      default: 'true',
    },
    status: {
      type: String,
      default: 'normal'
    },
    duration: {
      type: Number,
      default: 3000,
    }
  },
  mounted() {
    setTimeout(() => {
      this.hideToast();
    }, this.duration);
  },
  methods: {
    hideToast() {
      this.$emit("dismiss");
    },
  },
};
</script>
